import { IUrlId } from "@faire/deprecated-retailer-visitor-shared/models/Category/IUrlId";
import { QueryParameters } from "@faire/deprecated-retailer-visitor-shared/paths/category/QueryParameters";
import { InvalidSuppliersPathError } from "@faire/deprecated-retailer-visitor-shared/paths/suppliers/InvalidSuppliersPathError";
import { isTupleOfLength } from "@faire/typescript";
import { path as c1SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { path as c2SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId";
import { path as c3SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId/c3SuppliersUrlId";
import { logWarning } from "@faire/web/common/logging";
import type { IRoutingContext } from "@faire/web/common/routing/types";
import { prependLocaleToUrl } from "@faire/web/common/routing/util";

export const suppliersPath = ({
  urlIds,
  queryParams = {},
  routingContext,
}: {
  urlIds: [IUrlId, ...IUrlId[]] | [...IUrlId[], IUrlId];
  queryParams?: QueryParameters;
  routingContext: IRoutingContext;
}) => {
  const urlIdStrings = urlIds.map((urlId: IUrlId) => urlId.id);
  let suppliersPath = "";
  if (isTupleOfLength(urlIdStrings, 1)) {
    suppliersPath = c1SuppliersPath(...urlIdStrings);
  } else if (isTupleOfLength(urlIdStrings, 2)) {
    suppliersPath = c2SuppliersPath(...urlIdStrings);
  } else if (isTupleOfLength(urlIdStrings, 3)) {
    suppliersPath = c3SuppliersPath(...urlIdStrings);
  } else {
    // Category path is larger than the longest possible value. Log a warning and return the longest possible chain
    logWarning(
      new InvalidSuppliersPathError(
        `Tried to craft suppliers path with URL ID longer than 3 levels. URL IDs ${urlIdStrings}`
      )
    );
    suppliersPath = c3SuppliersPath(
      ...(urlIdStrings.slice(0, 3) as [string, string, string])
    );
  }

  // TODO: Once query parameters are properly defined on the backend, should be able to remove the localize path
  // and manually formatting the query parameters
  return prependLocaleToUrl(
    decodeURIComponent(suppliersPath) +
      QueryParameters.stringify(queryParams, { addQueryPrefix: true }),
    routingContext
  );
};
